<template>
  <small
    v-if="isOnboardingRedesign"
    class="tw-inline-flex tw-items-center tw-gap-2 tw-text-[#848484]"
  >
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.919922 6.87536C0.919922 6.38213 1.11586 5.9091 1.46463 5.56033C1.81339 5.21156 2.28642 5.01563 2.77966 5.01562H10.2186C10.7118 5.01562 11.1849 5.21156 11.5336 5.56033C11.8824 5.9091 12.0783 6.38213 12.0783 6.87536V11.2147C12.0783 11.708 11.8824 12.181 11.5336 12.5298C11.1849 12.8785 10.7118 13.0745 10.2186 13.0745H2.77966C2.28642 13.0745 1.81339 12.8785 1.46463 12.5298C1.11586 12.181 0.919922 11.708 0.919922 11.2147V6.87536ZM7.11904 8.11518C7.11904 7.95077 7.05373 7.7931 6.93747 7.67684C6.82121 7.56058 6.66354 7.49527 6.49913 7.49527C6.33472 7.49527 6.17704 7.56058 6.06078 7.67684C5.94453 7.7931 5.87921 7.95077 5.87921 8.11518V9.97492C5.87921 10.1393 5.94453 10.297 6.06078 10.4133C6.17704 10.5295 6.33472 10.5948 6.49913 10.5948C6.66354 10.5948 6.82121 10.5295 6.93747 10.4133C7.05373 10.297 7.11904 10.1393 7.11904 9.97492V8.11518Z"
        fill="#848484"
      />
      <path
        d="M4.01953 5.63626V3.77652C4.01953 3.11888 4.28078 2.48817 4.7458 2.02315C5.21083 1.55812 5.84153 1.29688 6.49918 1.29688C7.15682 1.29688 7.78753 1.55812 8.25255 2.02315C8.71758 2.48817 8.97882 3.11888 8.97882 3.77652V5.63626"
        stroke="#848484"
        stroke-width="1.11111"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    256-BIT TLS SECURITY
  </small>
  <small v-else>
    <b-icon icon="lock-fill" /> 256-BIT TLS SECURITY
  </small>
</template>

<script>
import { mapState } from 'vuex'
/**
import OnboardingTLSSecurity from '@/components/onboarding/OnboardingTLSSecurity'
 */
export default {
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  }
}
</script>